<template>
    <div class="vrm-modal vrm-modal--wider mfp-with-anim vrm-modal--replace-device-confirm">
        <div v-if="step === 0">
            <vrm-swap-devices-step-select
                :swap-installations-model="swapInstallationsModel"
            ></vrm-swap-devices-step-select>
        </div>
        <div v-else-if="step === 1">
            <vrm-swap-devices-step-confirm
                :swap-installations-model="swapInstallationsModel"
                :checkbox-value="checkboxValue"
            ></vrm-swap-devices-step-confirm>
        </div>
        <div v-else-if="step === 2">
            <div v-if="!successTransfer" class="modal_spinner">
                <spinner />
            </div>

            <vrm-swap-devices-step-result
                :success-transfer="successTransfer"
            ></vrm-swap-devices-step-result>
        </div>

        <modal-close-handle />
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import VrmDropdown from '@/vue/components/shared/VrmDropdown';
import VrmDropdownGx from '@/vue/components/shared/VrmDropdownGX';
import { ngInject } from '@/vue/decorators/angular-interop';
import { NOTIFICATION_TYPE_SUCCESS } from '@/vue/store/modules/notifications';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmInstallationCard from '@/vue/components/shared/VrmInstallationCard';
import VrmSwapDevicesStepSelect from '@/vue/components/modals/VrmSwapDevicesModalStepSelect.vue';
import VrmSwapDevicesStepConfirm from '@/vue/components/modals/VrmSwapDevicesModalStepConfirm.vue';
import VrmSwapDevicesStepResult from '@/vue/components/modals/VrmSwapDevicesModalStepResult.vue';
import Spinner from '@/vue/components/shared/device-controls/controls/components/Spinner';
@Component({
    components: {
        VrmInstallationCard,
        ModalCloseHandle,
        VrmDropdown,
        VrmDropdownGx,
        VrmSwapDevicesStepSelect,
        VrmSwapDevicesStepConfirm,
        VrmSwapDevicesStepResult,
        Spinner,
    },
    props: {
        initialStep: {
            type: Number,
            required: true,
        },
        swapInstallationsModel: {
            type: Object,
        },
    },
    data: function() {
        return {
            checkboxValue: false,
            saveDataAsSeparateInstallation: false,
            confirmed: false,
            askInstallationData: null,
            step: 0,
            successTransfer: false,
        };
    },
    created() {
        if (this.initialStep) {
            // to pass step from general controller
            this.step = this.initialStep;
        }
        // get all available installations of a user
    },
    methods: {
        setWizardStep(value) {
            this.step = value;
        },
        tickCheckBox() {
            this.checkboxValue = !this.checkboxValue;
        },
        async tryToTransfer() {
            if (!this.swapInstallationsModel.selectedInstallation) return;

            const targetInstallation = this.swapInstallationsModel.currentInstallation.id;
            const selected = this.swapInstallationsModel.selectedInstallation.identifier;

            this.ApiService.installations(
                targetInstallation,
                'transfer-site',
                {
                    identifier: selected,
                },
                'POST',
            )
                .then(response => {
                    if (response && response.data && response.data.success) {
                        this.vrmNotificationsService.add({
                            type: NOTIFICATION_TYPE_SUCCESS,
                            message: this.$t('general.swapped'),
                        });
                        this.successTransfer = true;
                    }
                })
                .catch(err => {
                    if (err.data.error_code) {
                        this.confirmClose();
                    }
                });
        },
        confirmClose() {
            this.$emit('close', false);
        },
    },
})
@AngularLocaleBundle('general')
export default class ConfirmSwapDevices extends Vue {
    @ngInject()
    ApiService;

    @ngInject()
    vrmNotificationsService;

    @ngInject()
    SwapInstallationService;
}
</script>
